import { createContext, ReactNode, useContext } from 'react';
import {
    defaultCompanySectors,
    defaultContactGender,
    defaultDealPipelineStatuses,
    defaultDealStages,
    defaultLogo,
    defaultNoteStatuses,
    defaultTitle,
    defaultPersonType,
} from './defaultConfiguration';
import { ContactGender, CustomerSector, DealStage, NoteStatus, PersonType } from '../types';

// Define types for the context value
export interface ConfigurationContextValue {
    companySectors: CustomerSector[];
    dealPipelineStatuses: string[];
    dealStages: DealStage[];
    noteStatuses: NoteStatus[];
    title: string;
    logo: string;
    contactGender: ContactGender[];
    personType: PersonType[];
}

export interface ConfigurationProviderProps extends ConfigurationContextValue {
    children: ReactNode;
}

// Create context with default value
export const ConfigurationContext = createContext<ConfigurationContextValue>({
    companySectors: defaultCompanySectors,
    dealPipelineStatuses: defaultDealPipelineStatuses,
    dealStages: defaultDealStages,
    noteStatuses: defaultNoteStatuses,
    title: defaultTitle,
    logo: defaultLogo,
    contactGender: defaultContactGender,
    personType: defaultPersonType,
});

export const ConfigurationProvider = ({
    children,
    companySectors,
    dealPipelineStatuses,
    dealStages,
    logo,
    noteStatuses,
    title,
    contactGender,
    personType,
}: ConfigurationProviderProps) => (
    <ConfigurationContext.Provider
        value={{
            companySectors,
            dealPipelineStatuses,
            dealStages,
            logo,
            noteStatuses,
            title,
            contactGender,
            personType,
        }}
    >
        {children}
    </ConfigurationContext.Provider>
);

export const useConfigurationContext = () => useContext(ConfigurationContext);
